import { useMemo } from 'react';
import { Tabs } from '@octano/global-ui';
import { TabsList } from '@octano/global-ui';
import { Tab } from '@octano/global-ui';
import { TabPanels } from '@octano/global-ui';
import { TabPanel } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import StudentPersonalInformation from './studentPersonalInfo/StudentPersonalInformation';
import AcademicHistory from './academicHistory/AcademicHistory';
import StudentAcademicHistoryLoader from './academicHistory/parts/StudentAcademicHistoryLoader';
import { StudentTutors } from './studentTutors';
import { RequestsHistory } from './petitionsHistory';
import { EducationalInformation } from './educationalInformation/EducationalInformation';
import { StudentDocuments } from './StudentDocuments';
import { ContainerStudentObservations } from './StudentObservations';

export default function StudentFileTabs() {
  const { t } = useTranslation();
  const tabsPrefix = 'studentManagement';

  const tabs = useMemo(
    () => [
      {
        name: t(`tabs.personalInformation`),
        path: '',
        content: <StudentPersonalInformation />,
      },
      {
        name: t(`tabs.educationalInformation`),
        path: t(`tabs.educationalInformation`),
        content: <EducationalInformation />,
      },
      {
        name: t(`tabs.academicHistory`),
        path: t(`tabs.academicHistory`),
        content: (
          <StudentAcademicHistoryLoader>
            {(props) => <AcademicHistory {...props} />}
          </StudentAcademicHistoryLoader>
        ),
      },
      {
        name: t(`tabs.tutors.tabTitle`),
        path: '',
        content: <StudentTutors />,
      },
      {
        name: t(`tabs.petitionsHistory.tabTitle`),
        path: '',
        content: <RequestsHistory />,
      },
      {
        name: t(`tabs.studentDocuments.tabTitle`),
        path: '',
        content: <StudentDocuments />,
      },
      {
        name: t(`tabs.studentObservations.tabTitle`),
        path: '',
        content: <ContainerStudentObservations />,
      },
    ],
    [t],
  );
  return (
    <Tabs defaultTab={tabs[0].name}>
      <TabsList>
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            id={tab.name}
            children={t(`${tabsPrefix}.${tab.name}`)}
          />
        ))}
      </TabsList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.name} id={tab.name} children={tab.content} />
        ))}
      </TabPanels>
    </Tabs>
  );
}
